import { CocoHappy } from "./assets/coco-happy";
import { CocoSad } from "./assets/coco-sad";
import { CocoPaused } from "./assets/coco-paused";
import { colors } from "styles/constants/colors";
import {
  IDaysLeft,
  IUserNoticeData,
  IUserNoticeTitle
} from "./user-notice.types";

const UserNoticeData: IUserNoticeData = {
  PAID: {
    title: ({ userName, daysLeft }: IUserNoticeTitle): string =>
      daysLeft && daysLeft >= 15
        ? `Hai ${userName}, halaman ini khusus nampilin kelas-kelasmu. ✨`
        : `Hai  ${userName}, paketmu tinggal ${daysLeft} hari lagi. 😢`,
    desc: (daysLeft?: IDaysLeft): string =>
      daysLeft && daysLeft >= 15
        ? "Sekarang bisa belajar pake laptop di website Kelas Live, loh!"
        : "Lanjutin langganan biar bisa terus belajar ya, CoFriends.",
    actionButtonText: "Eksplor paket belajar",
    actionButtonCallback: () => console.log("clicked"),
    backgroundColor: (daysLeft?: IDaysLeft) =>
      daysLeft && daysLeft >= 15 ? colors.white : colors.yellow[200],
    color: colors.brand[500],
    mascotImage: CocoSad
  },
  TRIAL: {
    title: ({ userName, daysLeft }: IUserNoticeTitle): string =>
      `Hai ${userName}, Kelas Live gratis aktif selama ${daysLeft} hari.`,
    desc: () => "Coba gratis ini cuma ada sekali, loh. Ikut kelasnya, ya!",
    actionButtonText: "Eksplor paket belajar",
    actionButtonCallback: () => console.log("clicked"),
    backgroundColor: () => colors.white,
    color: colors.brand[500],
    mascotImage: CocoHappy
  },
  FREE_AFTER_TRIAL: {
    title: ({ userName }: IUserNoticeTitle): string =>
      `Hai ${userName}! Coba gratis Kelas Live udah abis.`,
    desc: () => "Langganan paket yuk, biar bisa lanjut belajar lagi.",
    actionButtonText: "Eksplor paket belajar",
    actionButtonCallback: () => console.log("clicked"),
    backgroundColor: () => colors.yellow[200],
    color: colors.brand[500],
    mascotImage: CocoSad
  },
  FREE_AFTER_PAID: {
    title: ({ userName }: IUserNoticeTitle): string =>
      `Hai ${userName}! Periode paketmu udah abis.`,
    desc: () => "Langganan lagi yuk, biar bisa lanjut belajar bareng.",
    actionButtonText: "Mau info bimbel",
    actionButtonCallback: () => console.log("clicked"),
    backgroundColor: () => colors.yellow[200],
    color: colors.brand[500],
    mascotImage: CocoSad
  },
  PAUSED: {
    title: ({ userName }: IUserNoticeTitle): string =>
      `Hai ${userName}! Maaf, nggak bisa ikut Kelas Live dulu. Cek status pembayaranmu, ya.`,
    desc: () => "",
    actionButtonText: null,
    actionButtonCallback: () => console.log("clicked"),
    backgroundColor: () => colors.yellow[200],
    color: colors.brand[500],
    mascotImage: CocoPaused
  }
};

export { UserNoticeData };
